import * as React from 'react';
import Badge, { BadgeProps } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 10,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

interface CustomizedBadgesProps {
    color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    badgeContent: number;
    right?: number;
    top?: number;
}

const CustomizedBadges: React.FC<CustomizedBadgesProps> = ({ badgeContent, color = "info" }) => {
    return (
        <StyledBadge badgeContent={badgeContent} color={color} max={Infinity} />
    );
}

export default CustomizedBadges;